import React, { useCallback, useContext, useEffect } from 'react'

export const MapContext = React.createContext(undefined)

export const useMapContext = () => useContext(MapContext)

export const useEffectWithMapContext = (fn, deps = []) => {
  const { map } = useMapContext()

  useEffect(() => (map ? fn(map) : undefined), [map, ...deps])
}

export const useCallbackWithMapContext = (fn, deps = []) => {
  const { map } = useMapContext()
  return useCallback(
    (...args) => {
      if (!map) return
      return fn(map, ...args)
    },
    [map, ...deps]
  )
}
